import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import moStaff from '../store/staff-size';

interface IProps { }
interface IState { }
let chart: any = null;

const StaffChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const industryRef = useRef<any>(null);
  const { staffTabActive, staffList } = moStaff;

  const emen: any = {
    元均营业收入: 'yuan_revenue_data',
    元均净利润: 'yuan_profit_data',
  };

  const showChartList = useMemo(() => {
    const active = emen[staffTabActive];
    const xData: any = [];
    const list: any = [];
    if (!isEmpty(staffList)) {
      staffList[active].forEach((ele: any) => {
        xData.push(ele.year);
        list.push(ele.value);
      });
    }
    return { xData, list };
  }, [staffList, staffTabActive]);

  const pepleList = useMemo(() => {
    const list: any = [];
    if (!isEmpty(staffList)) {
      staffList.staff_data.forEach((ele: any) => {
        list.push(ele.value);
      });
    }
    return list;
  }, [staffList]);

  const colorList = [Color.primary, Color.secondary, Color.two];

  const render = () => {
    if (chart) chart.dispose();
    chart = init(industryRef.current);
    const option = {
      color: [Color.primary, Color.secondary, Color.two],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
          label: { show: true },
        },
        formatter: (parmes: any) => {
          let htl = `<p  style="font-family: 'PingFang SC'">${parmes[0].name}</p>`;
          parmes?.forEach((element: any, i: number) => {
            htl += `<p style="margin-top:10px;display:flex;
                         justify-content: flex-start;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;background:${colorList[element.seriesIndex]};
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'PingFang SC'">${element.seriesName}</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';padding-top:4px;flex:1;text-align:right">
                        ${isNumber(element.value) ? `${round(element.value, 1)}` : '-'}
                      </span>
                   </p>`;
          });
          return htl;
        },
      },
      legend: {
        data: ['人员规模（人）', staffTabActive],
        bottom: 0,
        icon: 'circle',
      },
      grid: {
        left: 30,
        right: 10,
        bottom: 45,
        top: 30,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: showChartList?.xData,
        axisTick: { show: false },
        axisLine: {
          lineStyle: { color: Color.ccc },
        },
        axisLabel: {
          color: Color.blackColor(0.85),
          fontFamily: 'Roboto',
        },
      },
      yAxis: [{
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: { color: Color.ccc },
        },
        axisTick: { show: false },
        axisLabel: {
          show: true,
          formatter: (val: number) => {
            if (val === 0) return 0;
            return `${Number(val).toLocaleString()}`;
          },
          fontSize: 10,
          color: Color.blackColor(0.5),
          // fontFamily: 'Roboto',
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: Color.blackColor(0.08),
            width: 1,
            type: 'dashed',
          },
        },
      },
      {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: { color: Color.ccc },
        },
        axisTick: { show: false },
        axisLabel: {
          show: true,
          formatter: (val: number) => {
            if (val === 0) return 0;
            return `${Number(val).toLocaleString()}`;
          },
          fontSize: 10,
          color: Color.blackColor(0.5),
          // fontFamily: 'Roboto',
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: Color.blackColor(0.08),
            width: 1,
            type: 'dashed',
          },
        },
      }],
      series: [
        {
          name: '人员规模（人）',
          type: 'line',
          data: pepleList,
          label: {
            show: true,
            fontFamily: 'Roboto',
            position: 'top',
            formatter: (parme: any) => {
              if (parme.value === 0) return 0;
              return `${round(Number(parme.value), 0).toLocaleString()}`;
            },
            color: Color.primary,
          },
        },
        {
          name: staffTabActive,
          type: 'line',
          data: showChartList.list,
          yAxisIndex: 1,
          label: {
            show: true,
            fontFamily: 'Roboto',
            position: 'top',
            formatter: (parme: any) => {
              if (parme.value === 0) return 0;
              return `${round(Number(parme.value), 1).toLocaleString()}`;
            },
            color: Color.secondary,
          },
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    render();
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [staffTabActive, staffList]);

  return (
    <section className="staff-chart" ref={industryRef} />
  );
};

export default observer(StaffChart);
